import React from 'react';
import { Box, Card, Stack, Typography } from '@mui/joy';
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import ImageIcon from '@mui/icons-material/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';

/**
 * Get icon for file type
 */
const getFileIcon = (fileName, size = 24) => {
  const ext = fileName.split('.').pop()?.toLowerCase();
  const imageExts = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp'];
  const pdfExts = ['pdf'];
  const docExts = ['doc', 'docx', 'txt', 'rtf'];

  if (imageExts.includes(ext)) return <ImageIcon sx={{ fontSize: size, color: 'primary.500' }} />;
  if (pdfExts.includes(ext)) return <PictureAsPdfIcon sx={{ fontSize: size, color: '#e53935' }} />;
  if (docExts.includes(ext)) return <DescriptionIcon sx={{ fontSize: size, color: '#1976d2' }} />;

  return <InsertDriveFileOutlinedIcon sx={{ fontSize: size, color: 'neutral.500' }} />;
};

const DragPreview = ({ item, count = 1 }) => {
  if (!item) return null;

  const isFolder = item.type === 'folder';

  return (
    <Card
      variant="outlined"
      sx={{
        p: 1.5,
        bgcolor: 'background.surface',
        boxShadow: 'lg',
        borderRadius: 'md',
        minWidth: 180,
        maxWidth: 250,
        transform: 'rotate(-2deg)',
      }}
    >
      <Stack direction="row" alignItems="center" gap={1.5}>
        {isFolder ? (
          <FolderIcon sx={{ fontSize: 28, color: '#ffc107' }} />
        ) : (
          getFileIcon(item.name, 28)
        )}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            level="body-sm"
            fontWeight={500}
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {item.name}
          </Typography>
          {count > 1 && (
            <Typography level="body-xs" color="primary">
              +{count - 1} more items
            </Typography>
          )}
        </Box>
      </Stack>
    </Card>
  );
};

export default DragPreview;
